export default "__VITE_ASSET__jTwGnvoA__"